import { FieldError, formControlClass, formSelectClass, getNestedFieldError, hasNestedFieldError } from "@/shared/components/forms/FormFieldFeedback";
import { visaoExplicitaOptionsParaCadastro } from "@/shared/constants/visao-sistema.constants";
import { loginDefaultsParaFormularioPessoa } from "@/modules/people/presentation/person-usuario-login.utils";
import { PersonFormValues } from "@/modules/people/presentation/person.schema";
import { PersonProfilesFormMethods } from "./profile.types"
import { useEffect } from "react";
import { useFormState } from "react-hook-form";


interface UsuarioProfileProps {

  methods: PersonProfilesFormMethods

  podeVerUsuarios: boolean

  podeGerenciarAdministrador: boolean

  podeEditarVisaoUsuario: boolean

}


export function UsuarioProfile({ methods, podeVerUsuarios, podeGerenciarAdministrador, podeEditarVisaoUsuario }: UsuarioProfileProps) {

  const { errors } = useFormState<PersonFormValues>();

  const usuarioAtivo = methods.watch('usuario.ativo')

  const usuarioId = methods.watch('usuario.id')

  const defensorForm = methods.watch('defensor')

  const estagiarioForm = methods.watch('estagiario')

  const perfisOperacionaisForm = methods.watch('perfisOperacionais')

  const loginSenhaHabilitado = methods.watch('usuario.loginSenhaHabilitado') === true



  const existeRegistro = !!usuarioId

  const deveMostrarCampos = usuarioAtivo || existeRegistro

  const camposDesabilitados = existeRegistro && !usuarioAtivo

  const visaoError = getNestedFieldError(errors, 'usuario.visao')
  const visaoOptions = visaoExplicitaOptionsParaCadastro(podeGerenciarAdministrador)



  useEffect(() => {

    if (!usuarioAtivo || usuarioId) return

    const defaults = loginDefaultsParaFormularioPessoa({
      defensor: defensorForm,
      estagiario: estagiarioForm,
      perfisOperacionais: perfisOperacionaisForm ? [...perfisOperacionaisForm] : undefined,
    })

    methods.setValue('usuario.loginSenhaHabilitado', defaults.loginSenhaHabilitado)

    methods.setValue('usuario.loginTokenHabilitado', defaults.loginTokenHabilitado)

  }, [usuarioAtivo, usuarioId, defensorForm, estagiarioForm, perfisOperacionaisForm, methods])



  if (!podeVerUsuarios) {
    return null
  }

  return (

    <div className="card col-md-7">

      <div className="card-header">

        <div className="form-check" title="Ativa ou inativa a conta de usuário.">

          <input type="checkbox" className="form-check-input" id="usuario_ativo" {...methods.register("usuario.ativo")} />

          <label className="form-check-label" htmlFor="usuario_ativo">
            Habilitar Acesso ao Sistema
          </label>
        </div>

      </div>

      {deveMostrarCampos && (

        <div className="card-body row">

          <div className="col-md-4">
            <div className=" gap-4">
              <div className="form-check" title="Permite autenticação com CPF ou e-mail institucional e senha na tela de login tradicional.">
                <input type="checkbox" className="form-check-input" id="usuario_login_senha_habilitado" disabled={camposDesabilitados} {...methods.register('usuario.loginSenhaHabilitado')} />
                <label className="form-check-label" htmlFor="usuario_login_senha_habilitado">
                  Permitir login via usuário e senha
                </label>
              </div>

              <div className="form-check" title="Permite solicitar token de acesso informando o CPF vinculado à pessoa.">
                <input type="checkbox" className="form-check-input" id="usuario_login_token_habilitado" disabled={camposDesabilitados} {...methods.register('usuario.loginTokenHabilitado')} />
                <label className="form-check-label" htmlFor="usuario_login_token_habilitado">
                  Permitir login via token por CPF
                </label>
              </div>

            </div>
            <FieldError message={getNestedFieldError(errors, 'usuario.loginSenhaHabilitado')?.message} />
          </div>

          <div className="col-md-4">

            <div>
              <label htmlFor="usuario_senha" className="form-label">
                Senha:{usuarioAtivo && loginSenhaHabilitado && !usuarioId && <span className="text-danger"> *</span>}
              </label>
              <input id="usuario_senha" type="password" className={formControlClass(!!errors.usuario?.senha)} disabled={camposDesabilitados || !loginSenhaHabilitado} autoComplete="new-password" {...methods.register('usuario.senha' as any)} />
              <FieldError message={errors.usuario?.senha?.message} />

              <label htmlFor="usuario_visao" className="form-label mt-3">
                Visão no sistema
              </label>

              <select id="usuario_visao" className={formSelectClass(hasNestedFieldError(errors, 'usuario.visao'))} disabled={camposDesabilitados || !podeEditarVisaoUsuario} title={!podeEditarVisaoUsuario ? 'Somente administradores podem alterar a visão no sistema.' : undefined}                  {...methods.register('usuario.visao', { setValueAs: (value) => (value === '' || value == null ? '' : String(value)), })} >

                {visaoOptions.map((item) => (
                  <option key={item.value || 'auto'} value={item.value}>{item.label}</option>

                ))}

              </select>
              <FieldError message={visaoError?.message} />
            </div>

          </div>



          <div className="col-md-4">

            <div className="card">

              <div className="card-body">

                <div className="mb-3">

                  <input

                    id="usuario_corfundotabela"

                    type="color"

                    disabled={camposDesabilitados}

                    {...methods.register('usuario.corfundotabela')}

                  />

                  <label htmlFor="usuario_corfundotabela" className="form-label ms-3">

                    Cor fundo tabela

                  </label>

                </div>



                <div className="mb-3">

                  <input

                    id="usuario_corletratabela"

                    type="color"

                    disabled={camposDesabilitados}

                    {...methods.register('usuario.corletratabela')}

                  />

                  <label htmlFor="usuario_corletratabela" className="form-label ms-3">

                    Cor fonte tabela

                  </label>

                </div>



                <div className="ps-3 mt-3">

                  <div className="form-check">

                    <input

                      id="usuario_recebenotificacoes"

                      type="checkbox"

                      className="form-check-input"

                      disabled={camposDesabilitados}

                      {...methods.register('usuario.recebenotificacoes')}

                    />

                    <label htmlFor="usuario_recebenotificacoes" className="form-check-label">

                      Receber Notificações de Ações

                    </label>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>

  )

}


